module.exports = __webpack_public_path__ + "static/media/17.17084bc1.svg";